// Source: app/scripts/controllers/view-complaint-case.js
Auction.controller('ViewComplaintCaseController', [
  '$scope',
  '$filter',
  '$routeParams',
  '$location',
  'toaster',
  'crudService',
  '$modal',
  'Downloader',
  'Messages',
  function ($scope, $filter, $routeParams, $location, toaster, crudService, $modal, Downloader, Messages) {

    var caseService = crudService('cases', {
      'getCase': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/complaint_cases/:id'
      },
      'editComplaintCase': {
        method: 'POST',
        url: '/data/rest/complaint_cases/edit_complaint_case'
      },
      'getPortalDocumentsForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/portal_documents/by_case_id/:id'
      },
      'getOutgoingPortalDocumentsForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/portal_documents/get_outgoing_documents_for_case_id/:id'
      },
      'getIncomingPortalDocumentsForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/portal_documents/get_incoming_documents_for_case_id/:id'
      },
      'editPortalDocumentMetadata': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/portal_documents/edit_portal_document'
      },
      'deletePortalDocument': {
        method: 'DELETE',
        url: '/data/rest/portal_documents/:id'
      },
      'getForumMessagesForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/forum/get_forum_messages/:id'
      },
      'saveForumMessage': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/forum_messages'
      },
      'submitComplaintCase': {
        method: 'POST',
        url: '/data/rest/complaint_cases/submit_complaint_case'
      }
    });


    var forumService = crudService('forum', {
        'getForumMessagesForCase': {
          method: 'GET',
          isArray: true,
          url: '/data/rest/forum/get_forum_messages/:id'
        },
        'saveForumMessage': {
          method: 'POST',
          isArray: false,
          url: '/data/rest/forum_messages'
        },
        'submitForumMessage': {
          method: 'POST',
          isArray: false,
          url: '/data/rest/forum_messages/submit_forum_message'
        },
        'deleteForumMessage': {
          method: 'DELETE',
          isArray: false,
          url: '/data/rest/forum_messages/:id'
        },
        'saveAndSubmitForumMessage': {
          method: 'POST',
          isArray: false,
          url: '/data/rest/forum_messages'
        }

      }
    );


    var authorizationTariffService = crudService('authorization_tariffs', {
      'getComplaintCaseById': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/customs_declarations/by_complaint_case_id/:id'
      },
      'addCustomsDeclarationToComplainCase': {
        method: 'POST',
        url: '/data/rest/customs_declarations/add_customs_declaration_to_complaint_case'
      },
      'getDecisionById': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/decisions/by_complaint_case_id/:id'
      },
      'deleteCustomsDeclaration': {
        method: 'DELETE',
        url: '/data/rest/customs_declarations/:id'
      }
    });


    if ($routeParams && $routeParams.recordsTab) {
      $scope.recordsTab = $routeParams.recordsTab;
    }

    $scope.activateTab = function (rt) {
      var search = {
        recordsTab: rt
      };

      // if($routeParams && $routeParams.tab) {
      //   search.tab = $routeParams.tab;
      // }
      $scope.recordsTab = rt;
      // $location.search(search);
    };


    if ($routeParams && $routeParams.recordsDocumentTab) {
      $scope.recordsDocumentTab = $routeParams.recordsDocumentTab;
    }

    $scope.activateDocumentTab = function (rt) {
      var search = {
        recordsDocumentTab: rt
      };

      // if($routeParams && $routeParams.tab) {
      //   search.tab = $routeParams.tab;
      // }
      $scope.recordsDocumentTab = rt;
      // $location.search(search);
    };


    function loadComplaintCaseData(caseId) {
      authorizationTariffService.getComplaintCaseById({id: caseId}, function (data) {
        $scope.customsDeclarationList = data;
        $scope.customsDeclaration = {};
      });
      authorizationTariffService.getDecisionById({id: caseId}, function (data) {
        $scope.decision = data;
      });
    }

    function initEntity() {

      var portalCase;
      caseService.getCase({id: $routeParams.id}, function (data) {
        portalCase = data;
        $scope.allowEdit = false;
        $scope.entity = {};
        $scope.entity.portalCase = portalCase;
        $scope.forum = portalCase.forum;
        $scope.newForumMessage = {};
        $scope.customsDeclaration = {};


        $scope.chosenDocument = {};
        $scope.portalDocument = {};
        if (portalCase.aboutIndividual) {
          $scope.entity.forCompany = 0;
          $scope.entity.forIndividual = 1;
          $scope.forCompany = 0;
          $scope.forIndividual = 1;
          $scope.individual = portalCase.aboutIndividual;
          console.log('$scope in edit');
          console.log($scope);
        } else {
          $scope.entity.forCompany = 1;
          $scope.entity.forIndividual = 0;
          $scope.forCompany = 1;
          $scope.forIndividual = 0;
          $scope.company = portalCase.aboutCompany;
          // $location.path("/web_portal/web_portal_home_page/create_general_case");
          console.log('$scope in edit');
          console.log($scope);
        }
        $scope.activateTab(1);
        loadComplaintCaseData($scope.entity.portalCase.id);
        caseService.getOutgoingPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
          $scope.outgoingDocumentList = data;
          $scope.activateDocumentTab(1);
          caseService.getIncomingPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
            $scope.incomingDocumentList = data;
            caseService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
              $scope.forumMessagesList = data;
            });
          });
        });
      });
    }


    initEntity();


    $scope.editCase = function (portalCase) {
      caseService.editComplaintCase(portalCase, function (data) {
        $scope.entity.portalCase = portalCase;
        Messages.saved();
      })
    };


    $scope.downloadDocument = function () {
      if ($scope.chosenDocument.id) {
        Downloader.download('/data/rest/portal_attachments/get/' + $scope.chosenDocument.id);
      }
    };

    $scope.saveChosenDocumentMetadata = function () {
      if ($scope.chosenDocument.id) {
        caseService.editPortalDocumentMetadata(
          {
            id:  $scope.chosenDocument.id,
            description:  $scope.chosenDocument.description,
            typeId: $scope.chosenDocument.documentType.id
          }, function (data) {
            $scope.chosenDocument = data;
            Messages.saved();
          })
      }
    };


    $scope.outgoingDocumentsIndeks = -1;
    $scope.incomingDocumentsIndeks = -1;
    $scope.chooseOutgoingDocument = function (portalDocument, index) {
      $scope.chosenDocument = portalDocument;
      $scope.outgoingDocumentsIndeks = index;
      $scope.incomingDocumentsIndeks = -1;
    };
    $scope.chooseIncomingDocument = function (portalDocument, index) {
      $scope.chosenDocument = portalDocument;
      $scope.incomingDocumentsIndeks = index;
      $scope.outgoingDocumentsIndeks = -1;
    };




    $scope.modalAddOrEditCaseDocument = $modal({
      scope: $scope,
      template: 'forms/modals/add_or_edit_case_document.html',
      show: false
    });


    $scope.changeAttachmentForDocument = function () {
      if ($scope.chosenDocument.id) {
        $scope.portalDocument = $scope.chosenDocument;
        $scope.modalAddOrEditCaseDocument.show();
      }
    };

    $scope.savePortalDocument = function () {
      caseService.getPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
        $scope.documentList = data;
      });
      $scope.modalAddOrEditCaseDocument.hide();

      $scope.portalDocument = {};

    };

    $scope.showAddNewDocumentForm = function () {
      $scope.portalDocument = {};
      $scope.modalAddOrEditCaseDocument.show();
    };


    $scope.deletePortalDocument = function () {
      console.log('vo delete funkcija $scope');
      console.log($scope);

      if ($scope.chosenDocument.id) {
        caseService.deletePortalDocument({id: $scope.chosenDocument.id}, function () {
          caseService.getPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
            $scope.documentList = data;
            Messages.deleted();
            $scope.chosenDocument = {};
          });
        })
      }

    };

    $scope.saveForumMessage = function (forumMessage) {
      forumMessage.forum = $scope.forum;
      forumMessage.bodySR = forumMessage.bodySQ;
      forumMessage.bodyEN = forumMessage.bodySQ;

      caseService.saveForumMessage(forumMessage, function (data) {
        caseService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
          $scope.forumMessagesList = data;
          $scope.newForumMessage = {};
        });
      })

    };


    $scope.submitForumMessage = function (forumMessage) {
      forumService.submitForumMessage(forumMessage.id, function (data) {
        forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
          $scope.forumMessagesList = data;
          $scope.newForumMessage = {};
        });
      })
    };


    $scope.saveAndSubmitForumMessage = function (forumMessage) {
      console.log("forum message: ", forumMessage);
      forumMessage.forum = $scope.forum;
      forumMessage.bodySR = forumMessage.bodySQ;
      forumMessage.bodyEN = forumMessage.bodySQ;
      forumService.saveForumMessage(forumMessage, function (data) {
        $scope.forumMessage2 = data;
        console.log("vo save", data);
        forumService.submitForumMessage(data.id, function (data) {
          console.log("vo submit");
          console.log("forum message3: ", data);
          forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
            $scope.forumMessagesList = data;
            $scope.newForumMessage = {};
          });
        });
      });
    };

    $scope.deleteForumMessage = function (forumMessage) {
      forumService.deleteForumMessage({id: forumMessage.id}, function (data) {
        forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
          $scope.forumMessagesList = data;
          $scope.newForumMessage = {};
        });
      })
    };

    $scope.submitCase = function (id) {

      caseService.submitComplaintCase(id, function (data) {
        Messages.saved();
        initEntity()
        // $scope.entity.generalCase = data;
        // $scope.activateTab(3);
        // $scope.modalCreateGeneralCase.hide();
        // $scope.modalEditGeneralCase.show();
      })

    };

    $scope.addCustomsDeclaration = function (customsDeclaration) {
      customsDeclaration.complaintCase = $scope.entity.portalCase;
      authorizationTariffService.addCustomsDeclarationToComplainCase(customsDeclaration, function (data) {
        authorizationTariffService.getComplaintCaseById({id: $scope.entity.portalCase.id}, function (data) {
          $scope.customsDeclarationList = data;
          $scope.customsDeclaration = {};
        })
      })
    };


    $scope.removeDeclaration = function (customsDeclaration) {
      authorizationTariffService.deleteCustomsDeclaration({id: customsDeclaration.id}, function () {
        authorizationTariffService.getComplaintCaseById({id: $scope.entity.portalCase.id}, function (data) {
          $scope.customsDeclarationList = data;
          Messages.deleted();
        });
      })
    }


  }
]);
